module.exports = __webpack_public_path__ + "static/media/lg-california-rt-46.64858f12.jpg";